import { clamp } from './number.mjs';
"use strict";
function ensureArray(value) {
  return Array.isArray(value) ? value : [value];
}
const dedupe = arr => [...new Set(arr)];
const areEqualArrays = (a, b) => {
  if (a.length !== b.length) {
    return false;
  }
  if (!a.every(el => b.includes(el))) {
    return false;
  }
  return !b.every(el => a.includes(el)) ? false : true;
};
const arraySafeIndex = (array, index) => {
  const indexSize = array.length;
  return (index % indexSize + indexSize) % indexSize;
};
const arraySafeIndexFind = (array, index) => {
  const safeIndex = arraySafeIndex(array, index);
  return array[safeIndex];
};
const normalizeSortResult = sortResult => clamp(sortResult, -1, 1);
function createArrayFromInterfaceKeys(keyRecord) {
  return Object.entries(keyRecord).reduce((acc, [key, include]) => {
    if (include) {
      acc.push(key);
    }
    return acc;
  }, []);
}
const isNonEmptyArray = arr => arr.length > 0;
export { areEqualArrays, arraySafeIndex, arraySafeIndexFind, createArrayFromInterfaceKeys, dedupe, ensureArray, isNonEmptyArray, normalizeSortResult };
//# sourceMappingURL=array.mjs.map
